import Component from 'can/component/component';
import template from './hole-iframe.stache';

const iframeEnvironment =
    window.globalSettings.iframeEnvironment ||
    'usgamensbp.smtinternetservices.com';

Component.extend({
    tag: 'hole-iframe',
    template: template,
    viewModel: {
        define: {
            id: {
                type: 'number',
            },
            className: {
                type: 'string',
                value: '',
            },
            iframeEnvironment: {
                type: 'string',
                value: iframeEnvironment,
            },
        },
    },
});
